<template>
	<div>
		<BusinessBanner />
		<div class="content-zsy">
			<InventoryNavi />
			<div class="widget-location">
				<h3>발송신청</h3>
			</div>
			
			<el-form :model="ruleForm"  ref="ruleForm" label-width="0" >	
			<el-row style="display: flex;justify-content: center;align-items: center;padding:0 40px;">
				<el-col :xs="16" :sm="8" >
					<el-input v-model="search" class="unit-input" placeholder="상품코드 또는 상품명" ></el-input>
				</el-col>
				<el-col :xs="8" :sm="6" style="display:flex;gap:10px;">
					<el-button type="primary" @click="onSearch" >불러오기</el-button>
					<el-button style="background-color: #F7941D; border-color: #F7941D; color: #fff;" @click="onInventoryDialog" >선택하기</el-button>
				</el-col>
			</el-row>
			
			<table class="table-list mb50" v-if="!isMobile">
				<colgroup>
					<col width="90">
					<!-- <col width="106"> -->
					<col width="220">
					<col width="">
					<col width="100">
					<col width="100">
					<col width="100">
					<col width="90">
				</colgroup>
				<thead>
				<tr>
					<th>확인</th>
					<!-- <th>썸네일</th> -->
					<th>상품코드</th>
					<th>상품명</th>
					<th>수량</th>
					<th>잔여</th>
					<th>부가서비스</th>
					<th>삭제</th>
				</tr>
				</thead>
				<tbody id="items">
				    <tr class="item-info" v-for="(item, index) in ruleForm.items" 	:key="index" >   
						<td class="text-center">
							<el-button
							  size="mini"  type="primary" plain
							  @click="handleEdit(item.inventory_id)">확인</el-button>
						</td>   
					<!-- 	<td class="text-center">       <div class="thumb li_thumbnailFilePath"></div>   </td>  -->
						<td class="text-center">
							<div class="li_code">{{item.code}}</div>
						</td>   
						<td class="text-center">
							<el-input style="width: 80%;" v-model="item.goods_name" placeholder=""></el-input>
						</td>   
						<td class="text-center">
							<el-input  placeholder="" v-model="item.apply_quantity" type="number"></el-input>
						</td>   
						<td class="text-center" style="color:#333;">
							{{item.remaining_quantity}}
						</td>   
						<td class="text-center">
							<!--부가서비스 신청 버튼 申请附加服务按钮 -->
							<div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
								<el-button type="primary" size="mini" plain icon="el-icon-setting" @click="openExtraServicesDialog(index)" style="padding: 7px 10px;">
									선택
								</el-button>
								<div v-if="hasSelectedExtraServices(item)" style="margin-top: 5px; font-size: 11px; color: #ff5700; line-height: 1.2; word-break: break-all;">
									<span style="font-weight: bold;">{{ formatSelectedExtraServices(item) }}</span>
								</div>
							</div>
						</td>
						<td class="text-center">
							<el-button
							  size="mini"
							  type="danger" plain
							  @click="handleDelete(index)">삭제</el-button>
						</td>
					</tr>
					<!-- <tr class="item-info">
						<td class="text-center">
							<el-button
							  size="mini"  type="primary" plain
							  @click="handleEdit()">확인</el-button>
						</td>   
						<td class="text-center">
							<div class="li_code">456789</div>
						</td>   
						<td class="text-center">
							<el-input style="width: 80%;" placeholder=""></el-input>
						</td>   
						<td class="text-center">
							<el-input  placeholder=""></el-input>
						</td>   
						<td class="text-center">
							2
						</td>   
						<td class="text-center">
							<el-button
							  size="mini"
							  type="danger" plain
							  @click="handleDelete()">삭제</el-button>
						</td>
					</tr> -->
				</tbody>
			</table>
			<div style="margin: 0 10px;"  v-else >
				<table class="table-list mb50">
					<tbody id="items">
						<tr class="item-info" v-for="(item, index) in ruleForm.items" 	:key="index">
							<td>       
								<div class="item-info-wrapper">
									<div class="item-info-top text-left">               
										<div class="item-code"><span>상품코드 : </span><span class="li_code">{{item.code}}</span></div>
									</div>           
									<div class="item-info-middle">
										<div class="item-info-middle-left">
											<!-- <div class="thumb"><div class="li_thumbnailFilePath"></div></div> -->
										</div>
										<div class="item-info-middle-right">
											<div class="item-info-middle-right-top">
												<div><strong>상품명</strong></div>
												<el-input style="width: 80%;" v-model="item.goods_name" ></el-input>
											</div>
											<div class="item-info-middle-right-bottom">
												<div><strong>단가</strong></div>
												<el-input style="width: 60%;" v-model="item.apply_quantity" type="number"></el-input>
												<div class="quantity-wrap">잔여 : <strong class="li_restQuantity color-blue" style="font-weight: normal">{{item.remaining_quantity}}</strong></div>
											</div>
										</div>           
									</div>           
									

									<div class="item-info-bottom text-left">               
										<!--부가서비스 신청 버튼 - 单独一行-->
										<div style="margin: 0 0 20px 0px; display: flex; align-items: center; flex-wrap: wrap;">
											<el-button type="primary" size="mini" plain icon="el-icon-setting" @click="openExtraServicesDialog(index)">
												부가서비스 신청
											</el-button>
											<div v-if="hasSelectedExtraServices(item)" style="margin-left: 15px; font-size: 12px; color: #666; line-height: 1.6;">
												<strong style="color: #ff5700;font-size:15px;">신청한 부가 서비스: </strong>
												<span style="font-weight: 500; color: #333;">{{ formatSelectedExtraServices(item) }}</span>
											</div>
										</div>
										<el-button
										  size="mini"  type="primary" plain
										  @click="handleEdit(item.inventory_id)">확인</el-button>
										<!-- <button type="button" class="btn btn-danger btn-xs event-click-item-delete">삭제</button> -->
										<el-button
										  size="mini"
										  type="danger" plain
										  @click="handleDelete(index)">삭제</el-button>
										   
									</div>
								</div>   
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			
			
			
			<div class="type-card shadow-all" style="margin-bottom: 30px;">
				<div class="card-head">
				    부가서비스 신청 내역
				</div>
				<div class="card-body">
					<div class="card-help">
						부가서비스 상세내역을 꼭! 확인하세요.
						<a href="/bizAddService" class="type-1 link-btn" style="width: 100px;" target="_blank">
						바로가기<i class="el-icon-top-right"></i>
						</a>
					</div>
					<el-row class="col-wrap">
						
						<el-col :xs="24" :sm="12" >
							<div class="group">
								<h4>포장</h4>
								<el-radio-group v-model="ruleForm.data.packing_level" style="width: 100%;" >
									<label class="checkbox-inline" v-for="(item,index) in agency_attach.packing_level" :key="index">
										<el-radio :label="item.id" >{{item.name}}
											<el-popover placement="top" width="400" trigger="hover">
													<div style="padding:10px 20px;" v-html="item.remarks"></div>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</el-radio>
										<span>{{item.subtitle}}</span>
									</label>		
								</el-radio-group>
								<el-checkbox-group v-model="ruleForm.data.add_packing" >
									<label class="checkbox-inline" v-for="(item,index) in agency_attach.add_packing" :key="index">
										<el-checkbox :label="item.id" >{{item.name}}
											<el-popover placement="top" width="400" trigger="hover">
													<div style="padding:10px 20px;" v-html="item.remarks"></div>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</el-checkbox>
										<span>{{item.subtitle}}</span>
									</label>			
								</el-checkbox-group>
							</div>
						</el-col>
						<el-col :xs="24" :sm="12" >
							<div class="group">
								<h4>기타</h4>
								<el-checkbox-group v-model="ruleForm.data.template" >
									<div style="display: flex;align-items: center;" v-for="(item,index) in agency_attach.template" :key="index" >
										<label class="checkbox-inline checkbox-inline-margin" style="width:80%;">
											<el-checkbox :label="item.id" >{{item.name}}
												<el-popover placement="top" width="400" trigger="hover">
														<div style="padding:10px 20px;" v-html="item.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{item.subtitle}}</span>
										</label>
										<el-input v-model="ruleForm.data[`template${item.id}_cnt`]" style="width:20%;margin-top: 10px;">
											<template slot="suffix">개</template>
										</el-input>
									</div>
								</el-checkbox-group>
								<el-checkbox-group v-model="ruleForm.data.customs" >
									<label class="checkbox-inline" style="width: 100%;" v-for="(item,index) in agency_attach.customs" :key="index">
										<el-checkbox :label="item.id" >{{item.name}}
											<el-popover placement="top" width="400" trigger="hover">
													<div style="padding:10px 20px;" v-html="item.remarks"></div>
													<i class="el-icon-question icon-question"  slot="reference"></i>
											</el-popover>
										</el-checkbox>
										<span>{{item.subtitle}}</span>
									</label>				
								</el-checkbox-group>
							</div>
						</el-col>
					</el-row>
				</div>  
			</div>
			
			<div class="type-card shadow-all">
				<div class="card-head">
					배송지 정보 입력
				</div>
				<div class="card-body">
					<div class="help-block"><strong>상품을 받으실 수취인 정보를 입력해 주세요.</strong>
						(수입신고자 명의로 통관을 진행하기 때문에 본인외에 수취인 정보를 입력할 경우, 세관에서 관계증명서 및 사유서 제출을 요구할 수 있습니다.)
					</div>
					
					<el-row style="border-top: 1px solid #333;padding: 20px 0 10px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							배송센터
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-radio-group v-model="ruleForm.data.delivery_center_code" style="display: flex;" @change="handleDeliveryCenterChange">
								<label class="checkbox-inline">
									<el-radio label='CN_SHIP' >해상</el-radio>
								</label>
								<!-- <label class="checkbox-inline">
									<el-radio label='CN_AIR' >항공</el-radio>
								</label> -->
								<label class="checkbox-inline">
									<el-radio label='CN_LCL' >LCL화물</el-radio>
								</label>
							</el-radio-group>
						</el-col>
					</el-row>
					<el-row style="padding: 0 0 10px;">	
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							통관방법 선택
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-radio-group v-model="ruleForm.data.customs_type" style="display: flex;" >
								<label v-if="ruleForm.data.delivery_center_code !== 'CN_LCL'" class="checkbox-inline">
									<el-radio label='2' >목록통관</el-radio>
								</label>
								<label v-if="ruleForm.data.delivery_center_code !== 'CN_LCL'" class="checkbox-inline">
									<el-radio label='1' >간이통관</el-radio>
								</label>
								<label class="checkbox-inline">
									<el-radio label='3' >사업자통관</el-radio>
								</label>
							</el-radio-group>
						</el-col>
					</el-row>
					<el-row style="padding: 0 0 20px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							관리코드
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-input v-model="ruleForm.data.refer_code" style="width: 300px;" maxlength="100" ></el-input>
						</el-col>
					</el-row>
					<el-row style="padding: 0 0 20px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							수취인명 <span class="color-blue">(필수)</span>
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-form-item  prop="data.realname"
							:rules="[{ required: true, message: '수취인명 필수', trigger: 'blur' },]">
								<el-input v-model="ruleForm.data.realname" style="width: 300px;" maxlength="100" ></el-input>
							</el-form-item>  
						</el-col>
					</el-row>
					<el-row style="padding: 0 0 20px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							영문 수취인명 <span class="color-blue">(필수)</span>
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-form-item  prop="data.realname2"
							:rules="[{ required: true, message: '영문 수취인명 필수', trigger: 'blur' },]">
								<el-input v-model="ruleForm.data.realname2" style="width: 300px;" maxlength="100" ></el-input>
							</el-form-item>  
						</el-col>
					</el-row>
					<el-row style="padding: 0 0 20px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							휴대폰번호 <span class="color-blue">(필수)</span>
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-row>
								  <el-col :xs="6" :sm="2">
										<el-form-item  prop="data.areacode"  >
										  <el-select style="width: 80px;" v-model="ruleForm.data.areacode" value-key="010" placeholder="">
											<el-option v-for="item in areacode_options" :label="item.label" :value="item.value" :key="item.value"></el-option>
										  </el-select>
										</el-form-item>
								  </el-col>
								  <el-col :xs="18" :sm="22">
									<el-form-item  prop="data.mobile"
									:rules="[
										{ required: true, message: '휴대폰번호 필수', trigger: 'blur' },
									]"
									>
										<el-input v-model="ruleForm.data.mobile" type="number" style="width: 200px;" ></el-input>
									</el-form-item>  
								  </el-col>
							</el-row>
						</el-col>
					</el-row>
					<el-row style="padding: 0 0 20px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							개인통관고유부호 <span class="color-blue">(필수)</span>
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-form-item  prop="data.customs_info"
							:rules="[
								{ required: true, message: '개인통관고유부호 필수', trigger: 'blur' },
								{ pattern: /^P[0-9]{12}$/, message: '대문자 P와 숫자 12자리(총 13자리)로 입력해주세요.', trigger: 'blur' }
							]">
								<el-input v-model="ruleForm.data.customs_info" style="width: 300px;" maxlength="13" ></el-input>
							</el-form-item>
							<div class="help-inline">
							    <!-- <span class="color-blue">유효성 확인</span> 버튼을 통해 정확한 개인통관 부호 정보를 입력하셨는지 확인 부탁드리겠습니다.<br> -->
								관세청 개인통관고유부호 발급 당시, 입력한 이름/연락처와 동일하지 않을 경우, 목록통관 접수가 불가할 수 있습니다.
							</div>
						</el-col>
					</el-row>
					
					<el-row style="padding: 0 0 20px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							주소 <span class="color-blue">(필수)</span>
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-form-item  prop="data.zipcode"
							:rules="[
								{ required: true, message: '우편번호 필수', trigger: 'blur' },
								{ pattern: /^[0-9]{5}$/, message: '우편번호는 5자리 숫자여야 합니다.', trigger: 'blur' }
							]">
								<el-input v-model="ruleForm.data.zipcode" style="width: 300px;" readonly placeholder="검색 버튼을 클릭하세요" >
									<el-button slot="append" icon="el-icon-search" @click="searchPostcode">검색</el-button>
								</el-input>
							</el-form-item>
							<el-form-item  prop="data.address"
							:rules="[{ required: true, message: '주소 필수', trigger: 'blur' }]">
								<el-input v-model="ruleForm.data.address" style="width: 100%;" readonly placeholder="우편번호 검색 시 자동 입력됩니다" ></el-input>
							</el-form-item>
							<el-form-item  prop="data.detailed_address"
							:rules="[{ required: true, message: '상세 주소 필수', trigger: 'blur' }]">
								<el-input v-model="ruleForm.data.detailed_address" style="width: 100%;" maxlength="100" placeholder="상세주소" ></el-input>
							</el-form-item> 
						</el-col>
					</el-row>
					<el-row style="padding: 0 0 20px;">
						<el-col :xs="24" :sm="4" class="background-color" style="font-weight: bold;">
							택배사 전달메세지
						</el-col>
						<el-col :xs="24" :sm="20">
							<el-input v-model="ruleForm.data.delivery_message" style="width: 100%;" maxlength="20" placeholder="20자 이내로만 입력할 수 있습니다." ></el-input>
						</el-col>
					</el-row>
					
				</div>
			</div>
			</el-form>
			
			<el-dialog  :visible.sync="DetailVisible" :width="isMobile?'98%':'1100px'" >
				<el-row>
					<el-col :xs="5" :sm="2" class="table-title">
						상품코드
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						{{info.code}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						바코드
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						{{info.barcode}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						등록일
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						{{info.createtime}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						배송센터
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						해상 ({{info.post_id}})
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						단가
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						{{info.price}} CNY
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						브랜드/셀러
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						{{info.seller}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						색상
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						{{info.color}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						사이즈
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content">
						{{info.size}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						HS CODE
					</el-col>
					<el-col :xs="19" :sm="10" class="table-content">
						{{info.hs_code}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						상품명
					</el-col>
					<el-col :xs="19" :sm="10" class="table-content">
						{{info.goods_name}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						적하품명
					</el-col>
					<el-col :xs="19" :sm="10" class="table-content">
						{{info.descript}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						품목분류
					</el-col>
					<el-col :xs="19" :sm="10" class="table-content">
						{{info.category}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title" style="font-size: 14px;">
						제품상세URL
					</el-col>
					<el-col :xs="19" :sm="22" class="table-content" style="align-items: flex-start;">
						<a referrerpolicy="no-referrer" :href="info.url" target="_blank">{{info.url}}</a>
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						입고신청
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content color-blue">
						{{info.warehouse_apply}}
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						입고
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content color-blue">
						0
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						발송신청
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content color-blue">
						0
					</el-col>
					<el-col :xs="5" :sm="2" class="table-title">
						잔여
					</el-col>
					<el-col :xs="7" :sm="4" class="table-content color-blue">
						0
					</el-col>
					
				</el-row>
				
				
			</el-dialog>

			
				  <!-- 商品个别附加服务申请弹窗 -->
				  <el-dialog title="상품 부가서비스 신청" :visible.sync="extraServiceDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :width="isMobile ? '95%' : '65%'" center>
				  <div class="type-card" v-if="currentExtraItem" style="box-shadow: none; border: none; margin-bottom: 0;">
					<div class="card-body" style="padding: 0px 10px;" >
						<el-row class="col-wrap">
							<el-col :xs="24" :sm="12" >
								<div class="group">
									<h4>포장</h4>
									<el-radio-group v-model="currentExtraItem.packing_level" style="width: 100%;" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.packing_level" :key="subIndex">
											<el-radio :label="subItem.id" >{{subItem.name}}
												<el-popover placement="top" width="400" trigger="hover">
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-radio>
											<span>{{subItem.subtitle}}</span>
										</label>		
									</el-radio-group>
									<el-checkbox-group v-model="currentExtraItem.add_packing" >
										<label class="checkbox-inline" v-for="(subItem, subIndex) in agency_attach.add_packing" :key="subIndex">
											<el-checkbox :label="subItem.id" >{{subItem.name}}
												<el-popover placement="top" width="400" trigger="hover">
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>			
									</el-checkbox-group>
								</div>
							</el-col>
							<el-col :xs="24" :sm="12" >
								<div class="group">
									<h4>기타</h4>
									<el-checkbox-group v-model="currentExtraItem.template" >
										<div style="display: flex;align-items: center;" v-for="(subItem, subIndex) in agency_attach.template" :key="subIndex" >
											<label class="checkbox-inline checkbox-inline-margin" style="width:80%;">
												<el-checkbox :label="subItem.id" >{{subItem.name}}
													<el-popover placement="top" width="400" trigger="hover">
															<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
															<i class="el-icon-question icon-question"  slot="reference"></i>
													</el-popover>
												</el-checkbox>
												<span>{{subItem.subtitle}}</span>
											</label>
											<el-input v-model="currentExtraItem[`template${subItem.id}_cnt`]" style="width:20%;margin-top: 10px;">
												<template slot="suffix">개</template>
											</el-input>
										</div>
									</el-checkbox-group>
									<el-checkbox-group v-model="currentExtraItem.customs" >
										<label class="checkbox-inline" style="width: 100%;" v-for="(subItem, subIndex) in agency_attach.customs" :key="subIndex">
											<el-checkbox :label="subItem.id" >{{subItem.name}}
												<el-popover placement="top" width="400" trigger="hover">
														<div style="padding:10px 20px;" v-html="subItem.remarks"></div>
														<i class="el-icon-question icon-question"  slot="reference"></i>
												</el-popover>
											</el-checkbox>
											<span>{{subItem.subtitle}}</span>
										</label>				
									</el-checkbox-group>
								</div>
							</el-col>
						</el-row>
					</div>  
				  </div>
				  <span slot="footer" class="dialog-footer">
					<el-button @click="clearCurrentExtraItemServices">선택 초기화</el-button>
					<el-button type="primary" @click="extraServiceDialogVisible = false">선택 완료</el-button>
				  </span>
				</el-dialog>

			<!--재고상품 선택 弹窗-->
			<el-dialog title="재고상품 선택하기" :visible.sync="inventoryVisible" :width="isMobile?'96%':'75%'" :close-on-click-modal="false">
				<!--搜索条件-->
				<div style="margin-bottom:15px;">
					<el-row :gutter="10">
						<el-col :xs="12" :sm="8" style="margin-bottom:10px;">
							<el-input v-model="inv_code" placeholder="상품코드" size="small" clearable></el-input>
						</el-col>
						<el-col :xs="12" :sm="8" style="margin-bottom:10px;">
							<el-input v-model="inv_goods_name" placeholder="상품명" size="small" clearable></el-input>
						</el-col>
						<el-col :xs="24" :sm="8" style="margin-bottom:10px;">
							<el-button type="primary" size="small" @click="onInvSearch">검색</el-button>
							<el-button size="small" @click="onInvReset">초기화</el-button>
						</el-col>
					</el-row>
				</div>
				<!--PC端表格-->
				<div v-if="!isMobile">
					<div style="display:flex; justify-content:space-between; align-items:flex-end; margin-bottom:10px;">
						<div style="font-size:14px;font-weight:bold;">
							전체 : <strong style="color:var(--main-color);">{{inv_total}}</strong>
						</div>
						<el-button style="background-color: #F7941D; border-color: #F7941D; color: #fff;" size="small" @click="onMultiSelectInventory">선택완료</el-button>
					</div>
					<el-table ref="inventoryTable" :data="inventoryData" @selection-change="handleSelectionChange" stripe empty-text="데이타가 없습니다." style="width:100%;" max-height="400">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column label="상태" width="120" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.status_name}}</span>
							</template>
						</el-table-column>
						<el-table-column label="상품코드 / 배송센터" width="160">
							<template slot-scope="scope">
								<div style="font-weight:bold;">{{scope.row.code}}</div>
								<div style="font-size:12px;color:#999;">해상</div>
							</template>
						</el-table-column>
						<el-table-column label="상품정보" min-width="200">
							<template slot-scope="scope">
								<div>{{ scope.row.goods_name }}</div>
								<div style="font-size:12px;color:#999;">
									<span v-if="scope.row.price">단가:{{ scope.row.price }} CNY,</span>
									<span v-if="scope.row.color">색상:{{scope.row.color}},</span>
									<span v-if="scope.row.size">사이즈:{{scope.row.size}}</span>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="입고신청 / 입고" width="140" align="center">
							<template slot-scope="scope">
								<!-- <div>{{ scope.row.apply_quantity }} / {{ scope.row.status==7?scope.row.apply_quantity:0 }}</div> -->
								<div>{{ scope.row.apply_quantity }} / {{ scope.row.stock_qty?scope.row.stock_qty:0 }}</div>	
							</template>
						</el-table-column>
						<el-table-column label="" width="80" align="center">
							<template slot-scope="scope">
								<el-button size="mini" type="primary" @click="onSelectInventory(scope.row)">선택</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--移动端卡片-->
				<div v-else style="max-height:400px;overflow-y:auto;">
					<div style="display:flex; justify-content:space-between; align-items:flex-end; margin-bottom:10px;">
						<div style="font-size:14px;font-weight:bold;">전체 : <strong style="color:var(--main-color);">{{inv_total}}</strong></div>
						<el-button style="background-color: #F7941D; border-color: #F7941D; color: #fff;" size="small" @click="onMultiSelectInventory">선택완료</el-button>
					</div>
					<div v-for="(item,index) in inventoryData" :key="index" style="border:1px solid #eee;border-radius:8px;padding:10px;margin-bottom:10px; position:relative;">
						<div style="position:absolute; top:10px; right:10px;">
							<el-checkbox v-model="item.checked" @change="handleMobileSelectionChange(item)"></el-checkbox>
						</div>
						<div style="font-weight:bold;font-size:13px;margin-bottom:5px; padding-right:25px;">
							<span style="color:var(--main-color);">[{{item.code}}]</span> {{item.goods_name}}
						</div>
						<div style="font-size:12px;color:#666;margin-bottom:8px;">
							<span>상태:{{item.status_name}}</span><br>
							<span v-if="item.price">단가:{{item.price}} CNY,</span>
							<span v-if="item.color">색상:{{item.color}}</span>
						</div>
						<div style="display:flex;justify-content:space-between;align-items:center;">
							<span style="font-size:12px;">입고: {{item.stock_qty}}</span>
							<el-button size="mini" type="primary" @click="onSelectInventory(item)">선택</el-button>
						</div>
					</div>
				</div>
				<!--分页-->
				<div style="text-align:center;padding-top:15px;">
					<el-pagination layout="prev, pager, next" :page-size="20" :total="inv_total" @current-change="onInvPageChange"></el-pagination>
				</div>
			</el-dialog>
			
			<div class="caution-box">
				<ul class="dot-list">
					<li>항공선적 불가상품 을 항공배송으로 신청 시 선적불가상품으로 인해 (상품압류 또는 폐기/출고불가)등이 발생할 수 있으며<br>
						상품이 고로켓고 중국물류센터로 리턴 시 착불 비용이 청구되며, 기타 추가 비용이 청구될 수 있습니다.</li>
					<li>국내 택배사 집하 거부로 유리제품, 도자기 류, 모니터 류, 가구 류는 국내 배송 파손 시 택배사 면책을 동의해야 출고 가능합니다.</li>
					<li>합포장·합배송 상품의 원포장자재가 부실할 경우 포장자재 신청해주셔야 합니다.</li>
					<li>포장자재 신청이 없을 경우 원포장으로 발송하며 이 경우 상품 혹은 구성품의 분실이 발생할 수 있으며 이 경우 고로켓고의 과실이 아닙니다.</li>
					<li>상품이 고로켓고 중국 물류센터 도착 후 현지 물동량에 따라 평균 입고/검수 1일이내, 배송요청 후 평균 1일 이내 포장완료되어 배송비 결제요청됩니다.<br>
						(단일상품은 입고, 검수, 포장, 발송까지 평균 1일 소요)</li>
					<li>신청서는 작성하신 내용 그대로 세관에 신고되므로, 허위 신고로 인한 모든 책임은 작성자 본인에게 있습니다.</li>
				</ul>
			</div>
			
			<div class="caution-agree">
					<label >
						<el-checkbox v-model="is_agree" >모든 작성사항을 확인하였으며 주의사항에 동의합니다.</el-checkbox>
					</label>
			</div>
			<p class="text-center mb50">
				<el-button type="primary" @click="submitForm" >등록하기</el-button>
			</p>
			
			
		</div>
		
	</div>
</template>

<script>
	import BusinessBanner from '../../components/BusinessBanner.vue'
	import InventoryNavi from '../../components/InventoryNavi.vue'
	import request from '@/utils/request'
	export default {
		components: {
			BusinessBanner,
			InventoryNavi
		},
		data() {
			return{
				search:"",
				index:"",
				
				ruleForm: {
					items: [],// 动态表单项数组
					data:{
						remove: [],
						check_level: '',
						packing_level: '',
						add_packing: [],
						template: [],
						customs: [],
						delivery_center_code:"",
						customs_type:"",
						refer_code:"",
						realname:"",
						areacode:"010",
						mobile:"",
						customs_info:"",
						zipcode:"",
						address:"",
						detailed_address:"",
						delivery_message:"",
						
					}
				},
				areacode_options: [
					{
						value: '010',
						label: '010'
					},{
						value: '011',
						label: '011'
					},{
						value: '016',
						label: '016'
					},{
						value: '017',
						label: '017'
					},{
						value: '018',
						label: '018'
					},{
						value: '019',
						label: '019'
					}
				],
				inventory_id:"",
				DetailVisible: false,
				info:"",
				is_agree:"",
				
				// 재고상품 선택 弹窗相关变量
				inventoryVisible: false,
				inventoryData: [],
				inv_code: '',
				inv_goods_name: '',
				inv_total: 0,
				inv_current_page: 1,
				inv_last_page: 1,
				inv_page: 1,
				inv_selected_items: [], // 选中的商品列表
				
				agency_attach: "",
				extraServiceDialogVisible: false,
				currentExtraServiceItemIndex: null,
				
			}
		},
		computed: {
			isMobile() {
				return window.innerWidth <= 768;
			},
			currentExtraItem() {
				if (this.currentExtraServiceItemIndex !== null && this.ruleForm.items[this.currentExtraServiceItemIndex]) {
					return this.ruleForm.items[this.currentExtraServiceItemIndex];
				}
				return null;
			}
		},	
		created(){
			this.getAgencyAttach();
			
		},
		methods: {
			getAgencyAttach(){
				request.post('/member/Agency/getAgencyAttach',{}
				).then(res => {
					if(res.code ==1){
						 this.agency_attach = res.data
					}		
				});
			},
			openExtraServicesDialog(index) {
				this.currentExtraServiceItemIndex = index;
				this.extraServiceDialogVisible = true;
			},
			clearCurrentExtraItemServices() {
				if (this.currentExtraItem) {
					const item = this.currentExtraItem;
					item.remove = [];
					item.check_level = '';
					item.packing_level = '';
					item.add_packing = [];
					item.template = [];
					item.customs = [];
					if (this.agency_attach && this.agency_attach.template) {
						this.agency_attach.template.forEach(t => {
							this.$set(item, `template${t.id}_cnt`, 1);
						});
					}
					this.$message.success('선택한 부가서비스가 모두 초기화되었습니다.');
				}
			},
			hasSelectedExtraServices(item) {
				return (
					(item.remove && item.remove.length > 0) ||
					(item.check_level !== '' && item.check_level !== null && item.check_level !== undefined) ||
					(item.packing_level !== '' && item.packing_level !== null && item.packing_level !== undefined) ||
					(item.add_packing && item.add_packing.length > 0) ||
					(item.template && item.template.length > 0) ||
					(item.customs && item.customs.length > 0)
				);
			},
			formatSelectedExtraServices(item) {
				if (!this.agency_attach) return '';
				const selected = [];
				const getName = (list, id) => {
					if (!list) return '';
					const found = list.find(x => x.id === id);
					return found ? found.name : '';
				};
				if (item.remove && item.remove.length > 0) {
					item.remove.forEach(id => {
						const name = getName(this.agency_attach.remove, id);
						if (name) selected.push(name);
					});
				}
				if (item.check_level !== '' && item.check_level !== null && item.check_level !== undefined) {
					const name = getName(this.agency_attach.check_level, item.check_level);
					if (name) selected.push(name);
				}
				if (item.packing_level !== '' && item.packing_level !== null && item.packing_level !== undefined) {
					const name = getName(this.agency_attach.packing_level, item.packing_level);
					if (name) selected.push(name);
				}
				if (item.add_packing && item.add_packing.length > 0) {
					item.add_packing.forEach(id => {
						const name = getName(this.agency_attach.add_packing, id);
						if (name) selected.push(name);
					});
				}
				if (item.template && item.template.length > 0) {
					item.template.forEach(id => {
						const name = getName(this.agency_attach.template, id);
						if (name) {
							const count = item[`template${id}_cnt`] || 1;
							selected.push(`${name}(${count}개)`);
						}
					});
				}
				if (item.customs && item.customs.length > 0) {
					item.customs.forEach(id => {
						const name = getName(this.agency_attach.customs, id);
						if (name) selected.push(name);
					});
				}
				return selected.join(', ');
			},
			handleDeliveryCenterChange(val) {
				if (val === 'CN_LCL') {
					if (this.ruleForm.data.customs_type === '1' || this.ruleForm.data.customs_type === '2') {
						this.ruleForm.data.customs_type = '3';
					}
				}
			},
			searchPostcode() {
				new window.daum.Postcode({
					oncomplete: (data) => {
						// data.zonecode: 邮政编码（5位）
						// data.address: 基本地址（道路名 或 地号）
						// data.roadAddress: 道路名地址
						// data.jibunAddress: 地号地址
						this.$set(this.ruleForm.data, 'zipcode', data.zonecode);
						this.$set(this.ruleForm.data, 'address', data.roadAddress || data.address);
						
						// 聚焦到详细地址输入框
						this.$nextTick(() => {
							const detailInput = this.$refs.ruleForm ? this.$refs.ruleForm.$el.querySelector('[prop="data.detailed_address"] input') : null;
							if (detailInput) detailInput.focus();
						});
					}
				}).open();
			},
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						if(this.is_agree){
							if(this.ruleForm.data.delivery_center_code==""){
								alert("배송센터 필수")
								return
							}
							if(this.ruleForm.data.customs_type==""){
								alert("통관방법 선택 필수")
								return
							}
							//检查是否为商业会员，只有商业会员能用
							console.log(this.ruleForm.items,"提交了")
							console.log(this.ruleForm.data,"提交了2")
							if(this.ruleForm.items.length<=0){
								alert("상품을 선택하지 않았습니다.")
								return
							}
							
							// 遍历数组
							for (let i = 0; i < this.ruleForm.items.length; i++) {
							    const item = this.ruleForm.items[i];
							
							    // 检查条件
							    if (item.apply_quantity > item.remaining_quantity) {
							        // 1. 弹出提示
							        alert("상품의 잉여가 부족하다.")
									return
							        // 2. 终止循环
							        // break; 
							    }
						
							    // 如果条件不成立，继续执行这里的代码
							    //console.log(`正在处理...`);
							}
							
							console.log("开始")
							request.post('/member/Inventory/addInventoryWarehouse',
								{
									"item":this.ruleForm.items,
									"data":this.ruleForm.data,
					
								}
							).then(response => {
								console.log(response,"提交?????")			  
								if(response.code ==1){
									alert('Success！！！');
									//console.log('稍后审核！');
									if (this.$route.query.type === 'coupang' || this.$route.query.activeMenu) {
										this.$router.replace({ query: { ...this.$route.query, type: 'coupang', activeMenu: 'coupang_inventory_packing' } }).catch(() => {});
									} else {
										this.$router.replace('/inventoryPacking').catch(() => {});
									}
							
								}else{
									alert(response.msg)
									return
								}
									
							});
							
						
						}else{
							alert("주의사항에 동의해야 등록이 가능합니다.")
						}
						
					} else {
						console.log('error submit!!');
						return false;
					}
					
				})
			},
			onSearch(){	
				request.post('/member/Inventory/sreachInventory',{
					search:this.search
				})
				.then(res => {
					console.log(res,"搜索库存商品")
					if(res.code ==1){
								
						// 删除 空项
						const ruleForm = this.ruleForm.items.filter(item => {
						  // 返回 true 的项会被保留，false 的项会被过滤（即“删除”）		 
						  return item.id!==res.data.id; 
						});
						this.ruleForm.items = ruleForm
					
						//this.addItem()
						this.ruleForm.items.push({
							id: res.data.id,
							inventory_id: res.data.inventory_id,
							code: res.data.code_i,
							goods_name: res.data.goods_name,
							apply_quantity:1,//数量
							inventory_warehouse_id:res.data.inventory_warehouse_id,
							remaining_quantity:res.data.remaining_quantity?res.data.remaining_quantity:0,//剩余 设置默认值 0
						})
						
					}else{
						alert(res.msg)
						return
					}		
				});
								
				
			},
			getInventoryGoods(){
				request.post('/member/Inventory/getInventoryGoods',{
					id:this.inventory_id
				})
				.then(res => {
					if(res.code ==1){
						console.log(res.data,"详细信息")
						this.info = res.data
					}		
				});
			},
			handleEdit(id){
				console.log(id)
				this.inventory_id = id
				this.DetailVisible = true
				this.getInventoryGoods()
			},
			handleDelete(index){
				this.ruleForm.items.splice(index, 1)
			},
			/**
			 * 打开재고상품선택弹窗
			 */
			onInventoryDialog(){
				this.inventoryVisible = true
				this.inv_page = 1
				this.getInventoryList()
			},
			/**
			 * 获取库存商品列表 (来自 InventoryWarehouseComplete 列表)
			 */
			getInventoryList(){
				request.post('/member/Inventory/getWarehouseList',{
					page: this.inv_page,
					s: this.inv_code ? 'code' : 'goods_name',
					k: this.inv_code || this.inv_goods_name || '',
					status: 'AACA', // 入库完成 (InventoryWarehouseComplete 状态)
				}).then(res => {
					if(res.code == 1){
						this.inv_total = res.data.total
						this.inv_current_page = res.data.current_page
						this.inv_last_page = res.data.last_page
						this.inventoryData = res.data.data
					}
				});
			},
			onInvSearch(){
				this.inv_page = 1
				this.getInventoryList()
			},
			onInvReset(){
				this.inv_code = ''
				this.inv_goods_name = ''
				this.inv_page = 1
				this.getInventoryList()
			},
			onInvPageChange(val){
				this.inv_page = val
				this.getInventoryList()
			},
			/**
			 * PC端表格选择项发生变化
			 */
			handleSelectionChange(val) {
				this.inv_selected_items = val;
			},
			/**
			 * 移动端卡片选择项发生变化
			 */
			handleMobileSelectionChange(selectedItem) {
				if(selectedItem.checked) {
					if(!this.inv_selected_items.find(item => item.id === selectedItem.id)) {
						this.inv_selected_items.push(selectedItem);
					}
				} else {
					this.inv_selected_items = this.inv_selected_items.filter(item => item.id !== selectedItem.id);
				}
			},
			/**
			 * 批量选择库存商品
			 */
			async onMultiSelectInventory(){
				if(this.inv_selected_items.length === 0) {
					this.$message.warning('선택된 상품이 없습니다.');
					return;
				}
				
				// 过滤全空项
				this.ruleForm.items = this.ruleForm.items.filter(item => {
					return item.goods_name !== '' && item.code !== ''
				})
				
				for(let row of this.inv_selected_items) {
					try {
						const res = await request.post('/member/Inventory/sreachInventory', { search: row.code,id:row.inventory_warehouse_id });
						if(res.code == 1){
							// 避免重复追加
							// this.ruleForm.items = this.ruleForm.items.filter(item => item.id !== res.data.id);
							this.ruleForm.items.push({
								id: res.data.id,
								inventory_id: res.data.inventory_id,
								code: res.data.code_i,
								goods_name: res.data.goods_name,
								apply_quantity: 1,
								inventory_warehouse_id: res.data.inventory_warehouse_id,
																remaining_quantity: res.data.remaining_quantity ? res.data.remaining_quantity : 0,
								remove: [],
								check_level: '',
								packing_level: '',
								add_packing: [],
								template: [],
								template15_cnt: 1,
								template16_cnt: 1,
								template17_cnt: 1,
								template18_cnt: 1,
								template19_cnt: 1,
								template20_cnt: 1,
								template21_cnt: 1,
								customs: [],
								show_extra_services: false
							});
						}
					} catch(e) {
						console.error(e);
					}
				}
				
				this.$message.success(`${this.inv_selected_items.length}개 상품이 추가되었습니다.`);
				this.inventoryVisible = false;
				this.inv_selected_items = []; 
				if (this.$refs.inventoryTable) {
					this.$refs.inventoryTable.clearSelection();
				}
			},
			/**
			 * 单选弹框项
			 */
			async onSelectInventory(row){
				this.ruleForm.items = this.ruleForm.items.filter(item => {
					return item.goods_name !== '' && item.code !== ''
				})
				
				try {
					const res = await request.post('/member/Inventory/sreachInventory', { search: row.code,id:row.inventory_warehouse_id });
					if(res.code == 1){
						this.ruleForm.items = this.ruleForm.items.filter(item => item.id !== res.data.id);
						this.ruleForm.items.push({
							id: res.data.id,
							inventory_id: res.data.inventory_id,
							code: res.data.code_i,
							goods_name: res.data.goods_name,
							apply_quantity: 1,
							inventory_warehouse_id: res.data.inventory_warehouse_id,
															remaining_quantity: res.data.remaining_quantity ? res.data.remaining_quantity : 0,
								remove: [],
								check_level: '',
								packing_level: '',
								add_packing: [],
								template: [],
								template15_cnt: 1,
								template16_cnt: 1,
								template17_cnt: 1,
								template18_cnt: 1,
								template19_cnt: 1,
								template20_cnt: 1,
								template21_cnt: 1,
								customs: [],
								show_extra_services: false
						});
						this.$message.success('상품이 추가되었습니다.');
					} else {
						this.$message.error(res.msg);
					}
				} catch(e) {
					console.error(e);
				}
				this.inventoryVisible = false;
			},
		}
	}
	
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.unit-input{
		width:100%;
	}
	/* 申请商品列表 */
	table.table-list {
	    width: 100%;
	    margin: 80px 0 10px 0;
	    padding: 0;
	    border-spacing: 0;
	    border-collapse: collapse;
	    table-layout: fixed;
	}
	.mb50 {
	    margin-bottom: 50px !important;
	}
	.table-list th {
	    font-size: 15px;
	    padding-top: 17px;
	    background-color: var(--secondary-color);
	}
	table.table-list thead th {
	    border-top: 2px solid #000;
	}
	table.table-list th, table.table-list td {
	    margin: 0;
	    vertical-align: middle;
	    border: solid 1px var(--border-color);
	    border-width: 1px 0;
	    text-align: center;
	    word-break: break-all;
	   /* font-size: 17px; */
	    padding: 15px 5px;
	}
	#items .item-info {
	    margin-bottom: 0;
/* 	    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1); */
	    border-radius: 15px;
	    background-color: #fff;
	}
	.text-center {
	    text-align: center !important;
	}
	.text-center .li_code{
		color: var(--background-color);
	}
	/*  */
	.type-card.shadow-all {
	    border: none;
	    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	}
	.type-card {
	    border: 1px solid var(--border-color);
	    border-radius: 26px;
	    overflow: hidden;
	}
	.card-head {
	    justify-content: flex-start;
	    padding-left: 40px;
	}
	.type-card > .card-head {
	    font-weight: 700;
	    font-size: 20px;
	    height: 66px;
	    line-height: normal;
	    display: flex;
	    align-items: center;
	   /* justify-content: center; */
	    color: #fff;
	    gap: 0 8px;
	    background: var(--secondary-color);
	}
	.type-card > .card-body {
	    padding: 26px;
	    background: #fff;
	}
	.card-body .help-block {
	    font-size: 17px;
	    background: #f4f8ff;
	    color: #274A80;
	    display: flex;
	    flex-direction: column;
	    justify-content: center;
	    align-items: flex-start;
	    /* height: 80px; */
	    padding: 10px 20px;
	    gap: 3px;
	    margin-bottom: 40px;
	}
	
	.caution-box {
	    border-radius: var(--border-radius);
	    background: #F5F6FB;
	    margin: 40px 0;
	}
	.caution-box ul {
	    font-size: 15px;
	    padding: 30px 30px 20px;
	}
	ul.dot-list {
	    margin: 0;
	    /* padding: 0; */
	    list-style: none;
		color: var(--background-color);
	}
	.caution-box ul li {
	    line-height: 22px;
	    margin-bottom: 10px;
	}
	ul.dot-list > li {
	    padding-left: 16px;
/* 	    line-height: 30px; */
	    position: relative;
	}
	.caution-box ul li:before {
	    top: 8px;
	}
	ul.dot-list > li:before {
	    content: '';
	    display: block;
	    position: absolute;
	   /* top: 12px; */
	    left: 0;
	    width: 6px;
	    height: 6px;
	    background: var(--main-color);
	    border-radius: 50%;
	}
	.caution-agree {
	    border: 1px solid var(--border-color);
	    text-align: center;
	    padding: 20px 0 21px;
	    margin-bottom: 30px;
	}
	.checkbox-inline{
		display: flex;
		align-items: center;
		border: 1px solid var(--border-color);
		border-radius: 14px;
		padding: 13px 10px !important;
		font-size: 15px;
		font-weight: bold;
		height: 50px;
		background-color: #fff;
		margin-bottom: 10px;
		margin-right: 10px;
	}
	.checkbox-inline span{
		margin-left: auto;
		color: #999;
		font-size: 13px;
		font-weight: 400;
	}
	.help-inline {
	    font-size: 15px;
	    color: rgba(0, 0, 0, 0.8);
	    margin-top: 9px;
	    margin-bottom: -2px;
	}
	/* 弹窗 */
	.table-title{
		background-color: #f5f8fd;font-size: 15px;min-height: 75px;display: flex;justify-content: center;align-items: center;
	}
	.table-content{
		border: 1px solid #f5f8fd;font-size: 14px;height: 75px;padding:0 10px;display: flex;align-items: center;overflow: hidden;
	}
	.table-content a{
		text-decoration: none;
		color: #337ab7;
	}
	
	
	.text-left {
	    text-align: left !important;
	}
	.color-blue {
	    color: var(--main-color) !important;
	}
	.background-color{
		color: var(--background-color);
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		/* 申请商品列表 */
		table.table-list {
		    border-top: 2px solid #000;
		}
		#items .item-info {
		    margin-bottom: 0;
		    padding: 20px;
		    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
		    border-radius: 15px;
		    background-color: #fff;
		}
		.item-code {
		    color: var(--main-color);
		    margin-bottom: 6px;
		    vertical-align: middle;
		    font-size: 13px;
		    line-height: 20px;
		    letter-spacing: -0.01em;
		}
		.item-code span {
		    vertical-align: middle;
		}
		.item-info .item-info-middle {
		    display: flex;
		    gap: 12px;
		}
		.item-info .item-info-middle .item-info-middle-right {
		    width: 100%;
		}
		.item-info .item-info-middle .item-info-middle-right-top, .item-info .item-info-middle .item-info-middle-right-bottom {
		    display: flex;
		    align-items: center;
		}
		.item-info .item-info-middle .item-info-middle-right-top {
		    margin-bottom: 8px;
		}
		.item-info .item-info-middle .item-info-middle-right-bottom {
		    margin-left: 11px;
		}
		.item-info .item-info-middle div strong {
		    margin-right: 8px;
		}
		.item-info .item-info-middle div strong, .item-info .item-info-middle div.quantity-wrap {
		    white-space: nowrap;
		    font-size: 13px;
		    line-height: 20px;
		    letter-spacing: -0.01em;
		}
		.item-info .item-info-middle div.quantity-wrap{
			padding-left: 10px;
		}
		.item-info-bottom{
			margin: 10px 20px;
		}
		
		
		.type-card {
		    border: 1px solid var(--border-color);
		    box-shadow: 8px 12px 12px rgba(0, 0, 0, 0.06);
		    border-radius: 26px;
		    overflow: hidden;
			margin:0 10px 30px;
		}
		.card-head {
			justify-content: flex-start;
		    padding-left: 20px;
		}
		.type-card .card-head{
			padding:15px;
			font-weight: 700;
			font-size: 18px;
	/* 		line-height: 23px; */
			display: flex;
			align-items: center;
			color: #fff;
			gap: 0 10px;
			background: var(--secondary-color);
		}
		.type-card .card-body {
		    padding: 20px;
		    background: #fff;
			font-size: 13px;
		}
		.card-body .help-block{
		    display: block;
		    margin-top: 5px;
		    margin-bottom: 10px;
			padding: 0 0;
		    color: #737373;
			background: #fff;
			font-size: 13px;
		}
		.caution-box{
			margin: 0 10px;
		}
		.caution-agree{
			margin: 40px 10px;
		}
		
	
	}

	.col-wrap {
	    display: flex;
	    flex-wrap: wrap;
	    /* border-top: 1px solid var(--border-color); */
	}
	.group h4 {
	    font-size: 17px;
	    font-weight: 700;
	    margin-bottom: 25px;
	}
	.group {
	    /* border-bottom: 1px solid var(--border-color);
	    border-right: 1px solid var(--border-color); */
	    padding: 30px;
	    height: 100%;
	}
	.checkbox-inline-margin {
	    margin-bottom: 5px;
	}
	.link-btn{
		margin-top: 10px;
		display: inline-flex;
		justify-content: center;
		align-items: center;
		border-radius: 19px;
		font-weight: 600;
		font-size: 12px;
		text-transform: uppercase;
		text-decoration: none !important;
		border: 1px solid var(--main-color);
		padding: 7px 17px;
		width:180px;
		transition: 0.25s;
		line-height: normal;
		cursor: pointer;
	}
	.link-btn.type-1 {
	    color: #fff;
	    background: var(--main-color);
	}

</style>